package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.MaterialSymbolType
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize

// TODO: Add something like `colors() data class` to avoid passing colorScheme around, or just create a proper style with a variant that takes in a variable for the star colors
@Composable
fun KsReviewStars(
    average: Double,
    starSize: CSSLengthOrPercentageNumericValue,
    modifier: Modifier = Modifier,
) {
    val activeColor = MaterialColorVars.Primary.value()
    val inactiveColor = MaterialColorVars.PrimaryContainer.value()

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        val fullStars = average.toInt()
        val hasHalfStar = (average % 1) >= 0.5
        val emptyStars = 5 - fullStars - if (hasHalfStar) 1 else 0

        repeat(fullStars) {
            DsMaterialSymbols(
                modifier = Modifier.fontSize(starSize),
                icon = "star",
                type = MaterialSymbolType.Rounded,
                fill = true,
                color = activeColor
            )
        }

        if (hasHalfStar) {
            DsMaterialSymbols(
                modifier = Modifier.fontSize(starSize),
                icon = "star_half",
                type = MaterialSymbolType.Rounded,
                fill = true,
                color = activeColor
            )
        }

        repeat(emptyStars) {
            DsMaterialSymbols(
                modifier = Modifier.fontSize(starSize),
                icon = "star_border",
                fill = true,
                type = MaterialSymbolType.Rounded,
                color = inactiveColor
            )
        }
    }
}
